import * as React from "react";

import { AutocompleteRenderGroupParams } from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";

import { misc } from "app/themes/colors";
import {
  ProductCategoryGroupHeading,
  categoryGroupHeading
} from "components/product-category-filter";

export const IN_STOCK_GROUP = "true";
export const NOT_IN_STOCK_GROUP = "false";

const inventorySx = {
  boxSizing: "border-box",
  border: `solid 3px ${misc.mutedPurple}`
};

export default function GroupedListItems({
  key,
  group,
  children
}: AutocompleteRenderGroupParams) {
  const isInStockGroup = group === IN_STOCK_GROUP;
  const categoryHeading = categoryGroupHeading(group);
  return (
    <Stack key={key} sx={isInStockGroup ? inventorySx : undefined}>
      {isInStockGroup && (
        <ListItemText
          sx={{
            p: 1,
            mt: -0.25,
            textAlign: "center",
            fontWeight: 800,
            background: misc.mutedPurple
          }}
        >
          In Stock
        </ListItemText>
      )}
      {categoryHeading && (
        <ProductCategoryGroupHeading>
          {categoryHeading}
        </ProductCategoryGroupHeading>
      )}
      <Box>{children}</Box>
    </Stack>
  );
}
